import "./locations.css";
import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";

function RevealOnScroll({ children, delay = 0 }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 20 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.6, ease: "easeOut", delay }}
    >
      {children}
    </motion.div>
  );
}

function Locations() {
  const pageVariants = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0, transition: { duration: 1 } },
    exit: { opacity: 0, y: -20, transition: { duration: 1 } },
  };

  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      <div className="locations-container">
        <RevealOnScroll>
          <div className="locations-1">
            <img src="https://i.imgur.com/lZW4xD4.jpeg" alt="img" />
            <div className="in-location">
              <p className="loc-p">
                Café Vista opened its doors in the summer of 2025 at 192 Main
                St. in Ridgefield Park, quickly gaining well-deserved attention
                for its high-quality coffee, fresh pastries, delicious breakfast
                offerings, and thoughtfully designed, Instagram-worthy
                interior.{" "}
              </p>
              <a href="https://cafevistarp.com/" target="_blank" className="loc-a">
                VISIT RIDGEFIELD PARK
              </a>
            </div>
          </div>
        </RevealOnScroll>
        <div className="locations-1">
          <RevealOnScroll>
            <img src="https://i.imgur.com/Zx4m14A.jpeg" alt="img" />
          </RevealOnScroll>
          <div className="in-location">
            <RevealOnScroll>
              <p className="loc-p">
                One year later, in 2021, the second location—Dream Vista—opened
                in Jersey City. Now a neighborhood favorite, Dream Vista is
                known for its exceptional breakfast, premium coffee, and its
                spacious backyard, where families can relax and kids can play
                while parents enjoy their favorite drinks. It’s also a popular
                destination for hosting private events and parties.
              </p>
            </RevealOnScroll>
            <RevealOnScroll>
              <a
                href="https://cafedreamvista.com/"
                target="_blank"
                className="loc-a-jc"
              >
                VISIT JERSEY CITY
              </a>
            </RevealOnScroll>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default Locations;
